// extracted by mini-css-extract-plugin
export default {"trigger":"styles_trigger__XpTsT"};